import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCrossInCircle = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M6.12024 7.39076L7.39089 6.12044L10.0015 8.73041L12.6077 6.12343L13.878 7.3941L11.2722 10.0007L13.8789 12.6067L12.6082 13.877L10.0019 11.2714L7.39251 13.8815L6.12222 12.6109L8.73123 10.0011L6.12024 7.39076Z",
			fill: "#AE050F"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M19.1673 10.0007C19.1673 15.0633 15.0633 19.1673 10.0007 19.1673C4.93804 19.1673 0.833984 15.0633 0.833984 10.0007C0.833984 4.93804 4.93804 0.833984 10.0007 0.833984C15.0633 0.833984 19.1673 4.93804 19.1673 10.0007ZM17.5007 10.0007C17.5007 14.1428 14.1428 17.5007 10.0007 17.5007C5.85852 17.5007 2.50065 14.1428 2.50065 10.0007C2.50065 5.85852 5.85852 2.50065 10.0007 2.50065C14.1428 2.50065 17.5007 5.85852 17.5007 10.0007Z",
			fill: "#AE050F"
		})
	]
});
const ForwardRef = forwardRef(SvgCrossInCircle);
export { ForwardRef as ReactComponent };
